export const en = {
    recommended_hotel_hint: 'Colleagues often chose this hotel for business trips and were satisfied',
};
